export default __webpack_public_path__ + "static/media/WheelAndTireProtection.1ecf3692.webp";